import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: `'DoubleBass', sans-serif`,
    body: `'Bryndan Write', sans-serif`,
  },
});

export default theme;
